import { nodesFlux } from '@candulabs/craft';
import React, { useMemo } from 'react';

import { toCssSelector } from '@candu-ai/stylesheet/utils';
import Node from 'craft/components/Node';
import { NodeTextMenu, TextAlignmentButtons } from 'craft/components/SelectedToolbar';
import { BuiltInComponents, TypographyVariants } from 'craft/constants';
import { useEditorSelector, useNodeContext } from 'craft/hooks';
import { TypographyStyles } from 'craft/resolvers/Typography/toolbox';
import { Resolver, ToolboxComponentSections } from 'craft/types';

import { ListItemVariantSelector } from './toolbox';

export const ListItem: Resolver = (props: any) => {
  const { id: nodeId } = useNodeContext();
  const customSelector = useMemo(() => nodesFlux.selectors.getNodeCustom(nodeId), [nodeId]);

  const { variant, variation } = useEditorSelector(customSelector).custom ?? {};

  const typographySelector = toCssSelector('typography', {
    variant: { variant, variation },
    output: 'html',
  });
  const propsWithVariant = {
    ...props,
    className: `${props.className || ''} ${typographySelector}`,
  };
  return <Node is="li" {...propsWithVariant} />;
};

ListItem.craft = {
  name: BuiltInComponents.ListItem,
  isCanvas: false,
};

ListItem.slate = {
  toCraftNode: (slateNode: any) => (craftNode: any) => {
    // eslint-disable-next-line
    craftNode.data.custom = {
      ...craftNode.data.custom,
      css: slateNode.data.css,
      collections: slateNode.data.collections,
      custom: {
        ...(craftNode.data.custom?.custom ?? {}),
        variant: slateNode.data.variant,
        variation: slateNode.data.variation,
      },
    };
  },
  toSlateNode: (craftNode: any) => (slateNode: any) => {
    // eslint-disable-next-line
    slateNode.data = {
      collections: craftNode.data.custom?.collections,
      css: craftNode.data.custom.css || {},
      isNodeDisabled: (craftNode.data.custom?.collections || []).length > 0,
      variant: craftNode.data.custom?.custom?.variant ?? TypographyVariants.P,
      variation: craftNode.data.custom?.custom?.variation,
    };
  },
};

ListItem.selectedToolbar = {
  customItems: [NodeTextMenu, TextAlignmentButtons],
};

ListItem.toolbox = {
  component: [TypographyStyles],
  responsiveComponent: [TypographyStyles],
  schema: {
    [ToolboxComponentSections.NameAndType]: {
      variantSelector: ListItemVariantSelector,
    },
    [ToolboxComponentSections.Layout]: {
      blockedDisplays: ['flex', 'inline-block'],
    },
    [ToolboxComponentSections.Size]: {
      hasOverflow: true,
    },
  },
};
